/**
 * What the /help home page features. CommonJS so scripts/check-content.js can
 * verify that every article referenced here exists -- the old home page's
 * hard-coded list pointed one card at a renumbered file for months.
 *
 * PLACEHOLDER CURATION. The content handover (7 Oct 2026) did not include the
 * popular-question groups or the quick actions; these follow the groups the
 * visual mock sketches, filled with the closest real articles, until Bimo sends
 * the final picks. Change the references here, not the components.
 */

/**
 * Chips under the hero search. The spec asks for 3-5 and for actions, not
 * articles: the first is the primary (solid) chip. Each entry has exactly one of
 * `href` (a storefront path), `article` ({ category, slug }) or `whatsapp`
 * (prefilled chat text).
 */
const quickActions = [
  { label: "Cek status order aku", href: "/user/history" },
  { label: "Lacak nomor resi", article: { category: "pengiriman-dan-resi", slug: "di-mana-lihat-nomor-resi" } },
  { label: "Ajukan klaim atau retur", article: { category: "klaim-dan-retur", slug: "alur-retur-dan-lama-prosesnya" } },
  { label: "Minta VA atau QRIS baru", whatsapp: "Halo Kyou, VA/QRIS untuk order aku sudah expired. Boleh minta yang baru?" }
];

/** "Yang paling sering ditanya": three questions per group, then "Lihat semua". */
const popularGroups = [
  {
    category: "pre-order",
    articles: [
      { category: "pre-order", slug: "udah-pre-order-nih-kyou-itemnya-sampai-kapan-ya" },
      { category: "pre-order", slug: "aku-punya-voucher-diskon-pre-order-cara-pakainya-gimana-kyou" },
      { category: "pre-order", slug: "kalau-sudah-pre-order-boleh-cancel-nggak-sih-kyou" }
    ]
  },
  {
    category: "order-and-payments",
    articles: [
      { category: "order-and-payments", slug: "pembayaran-va-bermasalah" },
      { category: "order-and-payments", slug: "saya-tidak-punya-atm" },
      { category: "order-and-payments", slug: "status-belum-terbayar" }
    ]
  },
  {
    category: "pengiriman-dan-resi",
    articles: [
      { category: "pengiriman-dan-resi", slug: "di-mana-lihat-nomor-resi" },
      { category: "pengiriman-dan-resi", slug: "paket-sudah-dikirim-belum-sampai" },
      { category: "pengiriman-dan-resi", slug: "notifikasi-pengiriman-artinya-apa" }
    ]
  },
  {
    category: "unique-request",
    articles: [
      { category: "unique-request", slug: "berapa-waktu-yang-dibutuhkan-agar-item-unique-request-sampai" },
      { category: "unique-request", slug: "apakah-harga-sudah-final" },
      { category: "unique-request", slug: "apa-yang-dimaksud-dengan-unique-request" }
    ]
  },
  {
    category: "ready-stock",
    articles: [
      { category: "ready-stock", slug: "stok-fisik-tidak-ketemu" },
      { category: "ready-stock", slug: "estimasi-item" },
      { category: "ready-stock", slug: "restock" }
    ]
  },
  {
    category: "klaim-dan-retur",
    articles: [
      { category: "klaim-dan-retur", slug: "syarat-video-unboxing" },
      { category: "klaim-dan-retur", slug: "batas-waktu-klaim" },
      { category: "klaim-dan-retur", slug: "alur-retur-dan-lama-prosesnya" }
    ]
  }
];

module.exports = { quickActions, popularGroups };
